import { EventEmitter, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of, switchMap } from 'rxjs';
import { first } from 'rxjs';
import { EdiMessageBase, EdiPricat, GungEdimessageType } from '../../models/edi';
import { AuthService } from '../auth/auth.service';
import { BackendInterceptor } from '../backend-interceptor/backend-interceptor.service';
import { EdiMessageBaseActionConfigService } from '../edi-message-base-action-config/edi-message-base-action-config.service';
import { EdiService } from '../edi/edi.service';
import { GungModalService } from '../gung-modal/gung-modal.service';
import { ActionButton, GungNotificationService } from 'gung-common';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class EdiPricatActionConfigService extends EdiMessageBaseActionConfigService {
  constructor(
    protected ediService: EdiService,
    protected gungModalService: GungModalService,
    protected authService: AuthService,
    protected backend: BackendInterceptor,
    protected router: Router,
    protected http: HttpClient,
    protected gungNotificationService: GungNotificationService
  ) {
    super(ediService, gungModalService, authService, backend, router, http, gungNotificationService);
  }

  protected getMessageType(): GungEdimessageType {
    return GungEdimessageType.PRICAT;
  }

  getButtons(item: EdiMessageBase, eventEmitter: EventEmitter<EdiMessageBase>): Observable<ActionButton<EdiMessageBase>[]> {
    return this.authService.getHasRoles('ACTUATOR').pipe(
      switchMap(isActuator => {
        const actions: ActionButton<EdiMessageBase>[] = [
          {
            title: 'EXPORT_PRICAT',
            action: (ediMessage: EdiMessageBase) => this.exportPricat(ediMessage as EdiPricat)
          }
        ];
        if (isActuator) {
          actions.push({
            title: 'DOWNLOAD_MESSAGE',
            action: (ediMessage: EdiMessageBase) => this.downloadMessage(ediMessage, event)
          });
          actions.push({
            title: 'ARCHIVE_MESSAGE',
            action: (ediMessage: EdiMessageBase) => this.archiveMessage(ediMessage, event, eventEmitter)
          });
        }
        return of(actions);
      })
    );
  }

  exportPricat(item: EdiPricat): void {
    this.gungModalService.openEdiPricatExportModal(item.id).then(
      result => {
        if (result) {
          this.http
            .post(`json/edi/v2/pricat/${item.id}/export`, { messageId: item.id, ...result })
            .pipe(first())
            .subscribe();
        }
      },
      () => {}
    );
  }
}
